
import svg4everybody from 'svg4everybody';
import { html } from './utils/environment';

export default function() {
    svg4everybody();

    // ==========================================================================
    // isMobile
    // ==========================================================================
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }

    const art = `%c
    .,,uod8B8bou,,.
    ..,uod8BBBBBBBBBBBBBBBBRPFT?l!i:.
,=m8BBBBBBBBBBBBBBBRPFT?!||||||||||||||
!...:!TVBBBRPFT||||||||||!!^^""'   ||||
!.......:!?|||||!!^^""'            ||||
!.........||||                     ||||
!.........||||  ##                 ||||
!.........||||                     ||||
!.........||||                     ||||
!.........||||                     ||||
!.........||||                     ||||
'.........||||                    ,||||
.;.......||||               _.-!!|||||
.,uodWBBBBb.....||||       _.-!!|||||||||!:'
!YBBBBBBBBBBBBBBb..!|||:..-!!|||||||!iof68BBBBBb....
!..YBBBBBBBBBBBBBBb!!||||||||!iof68BBBBBBRPFT?!::   '.
!....YBBBBBBBBBBBBBBbaaitf68BBBBBBRPFT?!:::::::::     '.
!......YBBBBBBBBBBBBBBBBBBBRPFT?!::::::;:!^"';:::       '.
!........YBBBBBBBBBBRPFT?!::::::::::^''...::::::;         iBBbo.
'..........YBRPFT?!::::::::::::::::::::::::;iof68bo.      WBBBBbo.
'..........:::::::::::::::::::::::;iof688888888888b.     'YBBBP^'
'........::::::::::::::::;iof688888888888888888888b.     '
'......:::::::::;iof688888888888888888888888888888b.
'....:::;iof688888888888888888888888888888888899fT!
'..::!8888888888888888888888888888888899fT|!^"'
  '' !!988888888888888888888888899fT|!^"'
      '!!8888888888888888899fT|!^"'
        '!988888888899fT|!^"'
          '!9899fT|!^"'
            '!^"'
    `;

    console.log(art, 'font-family: monospace');
    console.log(`%c website by piell.eth & devenini.eth `, 'background: #000; color: #FFF');
}
